/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import { TableNameType } from '../../../components/Table/types/tableTypes';
import { AccessComponentKeyEnum } from '../../../modules/role/constants/guard/guardConstants';
import { guardComponentType } from '../../../modules/role/reducer/guardReducer';
import { ExternalRoutePath } from '../../../routes/constants/externalRoutes';
import { CLIENT_ID, RoutePath } from '../../../routes/constants/routesConstants';
import { stringFormat } from '../../../utils/stringFormat';

export const getPageAutoReportIdUrl = (guardTypes: guardComponentType, id: string) =>
    guardTypes[AccessComponentKeyEnum.PageAutoReportId]
        ? RoutePath.autoReportId.replace(CLIENT_ID, id)
        : stringFormat(ExternalRoutePath.autoReport, id);

export const getPageAutoReportIdUrlRegex = (guardTypes: guardComponentType) =>
    guardTypes[AccessComponentKeyEnum.PageAutoReportId]
        ? RoutePath.autoReportId
        : ExternalRoutePath.autoReport;

export const isPageAutoReportIdUrlExternal = (guardTypes: guardComponentType) =>
    !guardTypes[AccessComponentKeyEnum.PageAutoReportId];


export const getPageAutoReportIdTableUrl = (id: string, tableName: TableNameType) =>
    (tableName === TableNameType.autoReportIdAccountEdit
        ? RoutePath.autoReportIdAccounts
        : RoutePath.autoReportIdSubscribers).replace(CLIENT_ID, id);

export const getPageAutoReportIdEditTableUrl = (id: string, tableName: TableNameType) =>
    (tableName === TableNameType.autoReportIdAccount
        ? RoutePath.autoReportIdAccountsEdit
        : RoutePath.autoReportIdSubscribersEdit).replace(CLIENT_ID, id);
